module.exports = __webpack_public_path__ + "img/car.5b89b797.jpg";